export const STATUS_TONE = {
  completed: { dot: 'bg-emerald-500', ring: 'ring-emerald-100', text: 'text-emerald-700' },
  rejected: { dot: 'bg-red-500', ring: 'ring-red-100', text: 'text-red-700' },
  pending: { dot: 'bg-slate-300', ring: 'ring-slate-100', text: 'text-slate-500' },
};

export const FILE_TYPE_LABEL = {
  TA1: 'TA1 — Envelope Acknowledgment',
  999: '999 — Functional Acknowledgment',
  ErrorReport: 'Error Report — Compliance Check',
  824: '824 — Application Advice',
  277: '277CA — Claim Status',
  835: '835 — Remittance / Payment',
};

export const PLANNED_MILESTONES = [
  '837P Submitted',
  'TA1 Envelope Ack',
  '999 Functional Ack',
  'Error Report (Compliance Check)',
  '824 Application Advice',
  '277CA Claim Status',
  '835 Remittance / Payment',
];

export { formatDateTime } from '../../lib/utils';

export const formatCurrency = (n) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n || 0);

export const formatBytes = (n) => {
  if (!n) return '—';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
};

export const buildTimelineWithPending = (received) => {
  const completedMilestones = new Set(received.map((t) => t.milestone));
  const out = [...received];
  for (const milestone of PLANNED_MILESTONES) {
    if (!completedMilestones.has(milestone)) {
      out.push({
        milestone,
        timestamp: null,
        status: 'pending',
        filename: null,
        details: 'Not yet received',
      });
    }
  }
  const orderIdx = (m) => PLANNED_MILESTONES.indexOf(m);
  return out.sort((a, b) => {
    if (!a.timestamp && !b.timestamp) return orderIdx(a.milestone) - orderIdx(b.milestone);
    if (!a.timestamp) return 1;
    if (!b.timestamp) return -1;
    return a.timestamp.localeCompare(b.timestamp);
  });
};

export const STATUS_BADGE_CLASS = (status) => {
  if (status === 'Paid') return 'bg-purple-100 text-purple-800';
  if (status === 'Accepted') return 'bg-emerald-100 text-emerald-800';
  if (status?.toLowerCase().includes('reject')) return 'bg-red-100 text-red-800';
  if (status === 'Acknowledged') return 'bg-blue-100 text-blue-800';
  return 'bg-slate-100 text-slate-700';
};
